const ICON_SIZE = 40;

export const searchHistoryStyles = {
	root: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: 2,
		p: 1,
		px: 2,
		color: 'text.primary',
		textDecoration: 'none',
		cursor: 'pointer'
	},
	details: {
		display: 'flex',
		flexDirection: 'row',
		gap: 1,
		alignItems: 'baseline',
		width: `calc(100% - ${ICON_SIZE}px - (2 * var(--mui-spacing)))`
	},
	iconContainer: {
		backgroundColor: 'primary.lighter',
		width: ICON_SIZE,
		height: ICON_SIZE,
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flex: '0 0 auto'
	},
	icon: {
		height: 15
	}
};
